/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateTriggeredActionRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/triggered_action_messages.pb'
import {UpdateTriggeredActionResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/triggered_action_messages.pb'


export const updateTriggeredAction = (request: UpdateTriggeredActionRequest, options?: CashRequestOptions) => post<UpdateTriggeredActionRequest, UpdateTriggeredActionResponse>("/2.0/cash/update-triggered-action", request, {...options, rejectOnError: true })